
export default {
  speed: 1,
  isAudio: false,
  src: '',
  type: '',
  vhsWithCredentials: false,
  poster: '',
  autoPlay: false,
  closeCaptionUrl: '',
  startTime: 0,
  nativeTextTracks: false,

  popMenuShow: false,
  popMarkerShow: false
};
